__turbopack_context__.v({
  "buttonLink": "MetabolicApp-module__ncTf9W__buttonLink",
  "buttons": "MetabolicApp-module__ncTf9W__buttons",
  "container": "MetabolicApp-module__ncTf9W__container",
  "content": "MetabolicApp-module__ncTf9W__content",
  "img": "MetabolicApp-module__ncTf9W__img",
  "linkArrow": "MetabolicApp-module__ncTf9W__linkArrow",
  "title": "MetabolicApp-module__ncTf9W__title",
});
